import React from 'react';

interface RefreshIconProps {
  className?: string;
  strokeWidth?: number | string;
}

/**
 * Refresh / cycle icon (Lucide-parity, 24x24 stroked). Used for the
 * "repeats every month" loop pill in the GetStarted scene (GEN-2188).
 */
export function RefreshIcon({
  className = 'h-4 w-4',
  strokeWidth = 2,
}: RefreshIconProps): React.ReactElement {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M21 12a9 9 0 1 1-2.64-6.36" />
      <path d="M21 3v5h-5" />
    </svg>
  );
}
